import React, { useState } from "react";
import DataTable from "../ui/DataTable";
import { FaEdit, FaTrash } from "react-icons/fa";
import PropTypes from "prop-types";

const StateTable = ({ data = [], onDelete, onEdit, pageSize = 10 }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      key: "serial",
      label: "SL No",
      sortable: false,
      render: (_, __, index) =>
        (currentPage - 1) * pageSize + index + 1
    },
    { key: "code", label: "State Code" },
    { key: "name", label: "State Name" },
    {
      key: "createdAt",
      label: "Created At",
      render: (value) => formatDate(value)
    }
  ];

  const actions = [
    {
      label: "Edit",
      icon: <FaEdit />,
      variant: "warning",
      onClick: (item) => onEdit(item),
      tooltip: "Edit state"
    },
    {
      label: "Delete",
      icon: <FaTrash />,
      variant: "danger",
      onClick: (item) => onDelete(item),
      tooltip: "Delete state"
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      actions={actions}
      searchable
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      pagination
      pageSize={pageSize}
      striped
      hover
      bordered
      responsive
      className="mt-3"
      onPageChange={setCurrentPage}
    />
  );
};

StateTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      createdAt: PropTypes.string
    })
  ),
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  pageSize: PropTypes.number
};

StateTable.defaultProps = {
  pageSize: 10
};

export default StateTable;
